import { styled, TextField } from "@mui/material";

export const AppFilterTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input::placeholder": {
    fontSize: "0.8rem",
  },
  "& .MuiInputBase-input": {
    padding: "6px",
  },
  "& .MuiOutlinedInput-root": {
    height: "34px"
  },
}));